export default [
    {
        path: "/",
        redirect: "/login"
    },
    {
        path:"/index",
        name: "index",
        redirect: "/index/dashboard",
        component: () => import("@/view/index/index.vue"),
        children: [
            {
                path:"/index/dashboard",
                name: "dashboard",
                meta: {
                    name:"資料總覽"
                },
                component: () => import("@/view/dashboard/dashboard.vue")
            },
            {
                path:"/index/category",
                name: "category",
                meta: {
                    name: "產品分類管理"
                },
                component: () => import("@/view/category/category.vue")
            },
            {
                path:"/index/commodity",
                name: "commodity",
                meta: {
                    name: "產品管理"
                },
                component: () => import("@/view/commodity/commodity.vue")
            },
            {
                path:"/index/account",
                name: "account",
                meta: {
                    name: "賬號管理"
                },
                component: () => import("@/view/account/account.vue")
            },
            {
                path:"/index/order",
                name: "order",
                meta: {
                    name: "訂單"
                },
                component: () => import("@/view/order/order.vue")
            },
            {
                path:"/index/suppilerOrder",
                name: "suppilerOrder",
                meta: {
                    name: "生成供應商訂單"
                },
                component: () => import("@/view/suppilerOrder/suppilerOrder.vue")
            },
            /*{
                path:"/index/homePage",
                name: "suppilerhomePageOrder",
                meta: {
                    name: "首頁管理"
                },
                component: () => import("@/view/homePage/homePage.vue")
            },*/
            {
                path:"/index/client",
                name: "client",
                meta: {
                    name: "客戶管理"
                },
                component: () => import("@/view/client/client.vue")
            },
        ]
    },
    {
        path:"/login",
        name: "login",
        component: () => import("@/view/login/login.vue")
    },
    
]